// extracted by mini-css-extract-plugin
module.exports = {"unresolvedComponent":"UnresolvedComponent_unresolvedComponent__2HtKT"};